  // Your web app's Firebase configuration
  import firebase from "firebase";
  var firebaseConfig = {
    apiKey: "AIzaSyDmibt1TMib_EU3rvPAWj31AaBHG3sFi00",
    authDomain: "indepth-reactjs-1.firebaseapp.com",
    databaseURL: "https://indepth-reactjs-1.firebaseio.com",
    projectId: "indepth-reactjs-1",
    storageBucket: "indepth-reactjs-1.appspot.com",
    messagingSenderId: "346532050208",
    appId: "1:346532050208:web:6c285f5a5af9439ce09345"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  export default firebase;